import { ClickyItem } from "../objects/ClickyItem";

export class MainScene extends Phaser.Scene {
    private background: Phaser.GameObjects.Image;
    private coins: Phaser.GameObjects.GameObject[] = [];

    constructor() {
        super({
            key: "MainScene"
        });
    }

    preload(): void {
        // All preloaded assets will be stored in the texture manager by the given key
        this.load.image("background", require("/src/assets/games/coinRunner/background.png"));
        this.load.image("player", require("/src/assets/games/coinRunner/player.png"));
        this.load.image("coin", require("/src/assets/games/coinRunner/coin.png"));
    }
    create(): void {
        // create background
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0, 0);

        // create objects
        var gameWidth = this.textures.game.config.width as number;
        var gameHeight = this.textures.game.config.height as number;
        for (let row = 0; row < 5; row++) {
            for (let col = 0; col < 5; col++) {
                let coin = new ClickyItem({
                    scene: this,
                    textureKey: "coin",
                    // x: row * 50,
                    // y: col * 50
                    x: (Math.random() * (gameWidth - 100)) + 50,
                    y: (Math.random() * (gameHeight - 100)) + 50
                });

                this.coins.push(coin);
                this.add.existing(coin);
            }
        }

        // DEBUG INFO
        let coin = this.coins[0];
        console.warn("Coin Info", coin); // JB - Remove this console.warn
        console.warn("Game Size", this.textures.game.config); // JB - Remove this console.warn
        // END DEBUG

        // Input dragables
        // This will fire anytime something that is draggable is dragged
        this.input.on('dragstart', function (pointer, gameObject) {
            // gameObject.setTint(0xff0000);
        });

        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            gameObject.x = dragX;
            gameObject.y = dragY;
        });

        this.input.on('dragend', function (pointer, gameObject) {
            // gameObject.clearTint();
        });
    }

    setupTouch() {
    }

    update(): void {
        // Update on screen objects
        // this.item.update();
    }

    private gameover(): void {
        this.scene.start("MainScene");
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserDragDropDemo/scenes/MainScene.ts